import { MainController } from './main_controller';

export default class ShopindexController extends MainController {
  click(e) {
    Turbolinks.visit($(e.currentTarget).data().href)
  }
}
